import React from 'react';
import { Shield } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
export function PricingSection() {
  return <section id="precio" className="px-4 py-12 bg-white max-w-md mx-auto" data-id="element-78">
      <div className="border-4 border-sage rounded-3xl p-5 text-center relative shadow-xl" data-id="element-79">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-sage text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-80">
          OFERTA LANZAMIENTO
        </div>

        <h2 className="text-2xl font-bold text-darkslate mb-1 mt-2" data-id="element-81">
          Acceso Completo al Método
        </h2>

        <div className="mt-3 mb-4" data-id="element-82">
          <p className="text-xs font-bold tracking-widest text-sage-dark uppercase mb-0.5" data-id="element-83">
            ACCESO DE POR VIDA
          </p>
          <p className="text-gray-400 line-through text-lg leading-tight" data-id="element-84">
            $25.000 ARS
          </p>
          <p className="text-6xl font-extrabold text-darkslate leading-none mt-1" data-id="element-85">
            $8.990
          </p>
          <p className="text-base font-extrabold text-red-600 mt-1.5 animate-pulse" data-id="element-86">
            ¡OFERTA DE LANZAMIENTO: 65% OFF SOLO HOY!
          </p>
        </div>

        {/* Payment Methods - Argentina */}
        <div className="flex justify-center items-center gap-4 mb-5" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/5bu8NcTseNueqXH1MX3wZJ/logo_mercado_pago.jpg" alt="Mercado Pago" className="h-12 w-auto object-contain" data-id="element-88" />
          <div className="flex items-center gap-3" data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/kuufamsUvkXT3VpPm8FCo2/logo_visa.jpg" alt="Visa" className="h-9 w-auto object-contain" data-id="element-90" />
            <svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-9 w-auto" data-id="element-91">
              <circle cx="20" cy="16" r="10" fill="#EB001B" data-id="element-92" />
              <circle cx="32" cy="16" r="10" fill="#F79E1B" data-id="element-93" />
              <path d="M26 8.1C28 9.8 29.3 12.3 29.3 16C29.3 19.7 28 22.2 26 23.9C24 22.2 22.7 19.7 22.7 16C22.7 12.3 24 9.8 26 8.1Z" fill="#FF5F00" data-id="element-94" />
            </svg>
          </div>
        </div>

        {/* Checkout Button */}
        <a href="https://tutiendadigi.shop/cart/52019288670488:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-cta hover:bg-cta-hover text-white font-extrabold py-5 px-6 rounded-xl text-xl border-b-4 border-green-700 active:border-b-0 active:translate-y-1 transition-all mb-5 text-center uppercase tracking-wide" style={{
        boxShadow: '0 6px 18px 0 rgba(34,139,34,0.45), 0 2px 6px 0 rgba(0,0,0,0.15)'
      }} data-id="element-95">
          OBTENER MI ACCESO INMEDIATO ➔
        </a>

        {/* Guarantee Shield */}
        <div className="bg-offwhite p-4 rounded-2xl flex items-start gap-3 text-left border border-sage/30" data-id="element-96">
          <Shield className="w-8 h-8 text-sage-dark shrink-0" strokeWidth={1.5} data-id="element-97" />
          <div data-id="element-98">
            <h4 className="font-bold text-sm text-darkslate" data-id="element-99">
              Garantía de Satisfacción 100%
            </h4>
            <p className="text-xs text-gray-600 mt-1" data-id="element-100">
              Si el protocolo no cumple tus expectativas en los primeros 7 días,
              te devolvemos el dinero. Tu compra está protegida y es 100%
              segura.
            </p>
          </div>
        </div>
      </div>
    </section>;
}